module.exports = __webpack_public_path__ + "img/NEBL.d22254ea.svg";